// Push model for admin-managed print settings.
//
// Admin sets Restaurant.printSettings (format fields + enabled + updatedAt) from the
// admin panel. The restaurant POS (this web app, loaded by the Electron shell) adopts
// them into its local `printerSettings` ONCE per admin push (keyed on updatedAt).
// After that the restaurant can still tweak settings on its own terminal; when admin
// re-pushes (new updatedAt) the new values are adopted again. The machine-specific
// selected printer (localStorage `selectedPrinter`) is NEVER touched — admin can't
// know each terminal's OS printer. No app release needed (all web-side).

const FORMAT_FIELDS = [
  'printEnabled', 'paperWidth', 'paperHeight', 'fontSize', 'fontWeight', 'lineHeight',
  'marginLeft', 'marginRight', 'marginBottom', 'printerType', 'printDirection',
  'printDensity', 'printSpeed', 'rasterBandHeight', 'kotEnabled', 'kotOnly',
];

// Adopt admin push into localStorage if it's a new push. Returns true if applied.
export function applyAdminPrintSettings(restaurant) {
  try {
    const admin = restaurant && restaurant.printSettings;
    if (!admin || !admin.enabled || !admin.updatedAt) return false;
    const stamp = String(admin.updatedAt);
    if (localStorage.getItem('adminPrintSettingsAppliedAt') === stamp) return false; // already applied this push
    const local = JSON.parse(localStorage.getItem('printerSettings') || '{}');
    const next = { ...local };
    for (const k of FORMAT_FIELDS) {
      if (admin[k] !== undefined && admin[k] !== null && admin[k] !== '') next[k] = String(admin[k]);
    }
    localStorage.setItem('printerSettings', JSON.stringify(next));
    localStorage.setItem('adminPrintSettingsAppliedAt', stamp);
    return true;
  } catch (_) {
    return false;
  }
}

// True when admin has an active push for this restaurant (for a "managed by admin" hint).
export function isAdminManaged(restaurant) {
  return !!(restaurant && restaurant.printSettings && restaurant.printSettings.enabled && restaurant.printSettings.updatedAt);
}
